import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { IIntegrationIntegrationInterfaceCompanyApi } from './base';
import { Result } from '../models/common/resultResponse';
import { IntegrationIntegrationInterfaceCompanySaveRequest } from '../models/request';
import { GetIntegrationIntegrationInterfaceCompanyResponse, IntegrationIntegrationInterfaceCompanySaveResponse } from '../models/response';
import { TimeoutRequestConfigurationEnum } from '../services/enum/TimeoutRequestConfigurationEnum';

const baseRoute: string = 'Integration_IntegrationInterface_Company';

export class IntegrationIntegrationInterfaceCompanyApi extends IIntegrationIntegrationInterfaceCompanyApi {
  private activeAbortController: AbortController | null = null;
  async getIntegrationinterfaceCompanyData(
    guidIntegrationInterface_Company: string
  ): Promise<AxiosResponse<Result<GetIntegrationIntegrationInterfaceCompanyResponse>>> {
    if (this.activeAbortController) {
      this.activeAbortController.abort();
    }
    this.activeAbortController = new AbortController();
    const response = await api.get(`${baseRoute}/getintegrationinterface_companydata`, {
      params: { guidIntegrationInterface_Company },
      signal: this.activeAbortController.signal,
      timeout: TimeoutRequestConfigurationEnum.OneMinuteInMilliseconds
    });
    this.activeAbortController = null;
    return response;
  }

  save(
    request: IntegrationIntegrationInterfaceCompanySaveRequest
  ): Promise<AxiosResponse<Result<IntegrationIntegrationInterfaceCompanySaveResponse>>> {
    return api.post(`${baseRoute}/save`, request);
  }
}
